import { api } from '@/api/api';
const systemApi = api.getSystemApi();
async function getRequestParamsAsync({ sid, account, domain, deviceId }) {
    const deviceInfo = await systemApi.getDeviceInfo();
    const res = Object.assign({ passtype: 2, support_verify_code: 0, account_name: account, domain,
        sid }, deviceInfo);
    res._deviceId = deviceId;
    return res;
}
function getNewImgVerifyCodeUrl(param) {
    const { baseUrl } = param;
    const ts = new Date().getTime();
    let res = `${baseUrl}?account_name=${decodeURIComponent(param.accountName)}`;
    res += `&domain=${decodeURIComponent(param.accountDomain)}`;
    res += `&sid=${decodeURIComponent(param.sid)}`;
    res += `&ts=${decodeURIComponent(String(ts))}`;
    return res;
}
export function getSignForCorpRenewSid(accessToken, accessSecret, timestamp) {
    const strPartArr = [`accessToken=${encodeURIComponent(accessToken)}`, `timestamp=${encodeURIComponent(timestamp)}`, `secret=${encodeURIComponent(accessSecret)}`];
    const signStr = strPartArr.join('&');
    return systemApi.sha1(signStr, true);
}
function getSignForReLogin(param) {
    const { accessSecret, accessToken, timeStamp } = param;
    const arr = [];
    arr.push(`accessToken=${encodeURIComponent(accessToken)}`);
    arr.push(`timestamp=${encodeURIComponent(timeStamp)}`);
    arr.push(`secret=${encodeURIComponent(accessSecret)}`);
    return systemApi.sha1(arr.join('&'), true);
}
export function getCorpAutoLoginParams(user) {
    const userProp = user === null || user === void 0 ? void 0 : user.prop;
    return {
        accountName: user === null || user === void 0 ? void 0 : user.accountName,
        domain: user === null || user === void 0 ? void 0 : user.domain,
        sessionId: user === null || user === void 0 ? void 0 : user.sessionId,
        accessToken: userProp === null || userProp === void 0 ? void 0 : userProp.accessToken,
        accessSecret: userProp === null || userProp === void 0 ? void 0 : userProp.accessSecret,
    };
}
export function getResponseLoginDataFromUser(user) {
    const result = {};
    result.uid = user.id;
    result.nickname = user.nickName;
    result.sid = user.sessionId;
    result.orgName = user.company;
    result.cookieName = user.cnName;
    const userProp = user.prop;
    result.accessToken = userProp === null || userProp === void 0 ? void 0 : userProp.accessToken;
    result.accessSecret = userProp === null || userProp === void 0 ? void 0 : userProp.accessSecret;
    return result;
}
export function getReLoginParams(user) {
    const ts = Math.floor(new Date().getTime() / 1000);
    const userProp = user.prop || {};
    const signInfo = {
        accessSecret: userProp.accessSecret,
        accessToken: userProp.accessToken,
        timeStamp: ts,
    };
    const res = {
        accessToken: userProp.accessToken,
        timestamp: ts,
        signature: getSignForReLogin(signInfo),
    };
    return res;
}
const CONSTANTS = {
    CORP_DEFAULT_PASSWORD: 'corpDefaultPsassWord',
    CORP_API_SUCCESS_CODE: '200',
    NETEASE_CORP_DOMAIN: 'corp.netease.com',
    NETEASE_MESG_CORP_DOMAIN: 'mesg.corp.netease.com',
    NETEASE_RESET_PWD_URL: 'https://reg.netease.com/corpMail/resetPwd.jsp',
    NETEASE_WEB_HOST: 'https://corp.netease.com',
};
function getIsNeteaseDomain(domain) {
    if (!domain)
        return false;
    const neteaseDomainArr = [CONSTANTS.NETEASE_CORP_DOMAIN, CONSTANTS.NETEASE_MESG_CORP_DOMAIN];
    return neteaseDomainArr.includes(domain);
}
export default {
    getRequestParamsAsync,
    getNewImgVerifyCodeUrl,
    getSignForCorpRenewSid,
    getCorpAutoLoginParams,
    getResponseLoginDataFromUser,
    getReLoginParams,
    CONSTANTS,
    getIsNeteaseDomain,
};
